<form [formGroup]="addPlasticProductSetupForm" class="flex-column" vdwBp.gt-sm="pr-64 half-width" vdwBp.lt-sm="full-width">
  <div class="flex-row gap-16">
    <mat-form-field class="full-width">
      <mat-label>{{ 'TEXTILE_DATA.PLASTIC_PRODUCT.MOUNT_TIME' | bmsTranslate }}</mat-label>
      <input matInput type="number" vdwL10nDecimal [decimals]="true" min="0" formControlName="mountTimeInMinutes" placeholder="0" />
      @if (addPlasticProductSetupForm.controls?.mountTimeInMinutes.value !== null && !addPlasticProductSetupForm.controls?.mountTimeInMinutes.disabled) {
        <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="addPlasticProductSetupForm.controls?.mountTimeInMinutes.reset()">
          <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
        </button>
      }
      <span matSuffix>
        {{ 'GENERAL.UNIT.MINUTE' | bmsTranslate }}
      </span>
      <mat-error *vdwCanShowErrorForFormControl="'mountTimeInMinutes'; error: 'min'">
        <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0}" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>{{ 'TEXTILE_DATA.PLASTIC_PRODUCT.DISMOUNT_TIME' | bmsTranslate }}</mat-label>
      <input matInput type="number" vdwL10nDecimal [decimals]="true" min="0" formControlName="dismountTimeInMinutes" placeholder="0" />
      @if (addPlasticProductSetupForm.controls?.dismountTimeInMinutes.value !== null && !addPlasticProductSetupForm.controls?.dismountTimeInMinutes.disabled) {
        <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="addPlasticProductSetupForm.controls?.dismountTimeInMinutes.reset()">
          <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
        </button>
      }
      <span matSuffix>
        {{ 'GENERAL.UNIT.MINUTE' | bmsTranslate }}
      </span>
      <mat-error *vdwCanShowErrorForFormControl="'dismountTimeInMinutes'; error: 'min'">
        <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0}" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="flex-row gap-16">
    <mat-form-field class="full-width">
      <mat-label>{{ 'TEXTILE_DATA.PLASTIC_PRODUCT.LOAD_TIME' | bmsTranslate }}</mat-label>
      <input matInput type="number" vdwL10nDecimal [decimals]="true" min="0" formControlName="loadTimeInMinutes" placeholder="0" />
      @if (addPlasticProductSetupForm.controls?.loadTimeInMinutes.value !== null && !addPlasticProductSetupForm.controls?.loadTimeInMinutes.disabled) {
        <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="addPlasticProductSetupForm.controls?.loadTimeInMinutes.reset()">
          <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
        </button>
      }
      <span matSuffix>
        {{ 'GENERAL.UNIT.MINUTE' | bmsTranslate }}
      </span>
      <mat-error *vdwCanShowErrorForFormControl="'loadTimeInMinutes'; error: 'min'">
        <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0}" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>{{ 'TEXTILE_DATA.PLASTIC_PRODUCT.UNLOAD_TIME' | bmsTranslate }}</mat-label>
      <input matInput type="number" vdwL10nDecimal [decimals]="true" min="0" formControlName="unloadTimeInMinutes" placeholder="0" />
      @if (addPlasticProductSetupForm.controls?.unloadTimeInMinutes.value !== null && !addPlasticProductSetupForm.controls?.unloadTimeInMinutes.disabled) {
        <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="addPlasticProductSetupForm.controls?.unloadTimeInMinutes.reset()">
          <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
        </button>
      }
      <span matSuffix>
        {{ 'GENERAL.UNIT.MINUTE' | bmsTranslate }}
      </span>
      <mat-error *vdwCanShowErrorForFormControl="'unloadTimeInMinutes'; error: 'min'">
        <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0}" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
    </mat-form-field>
  </div>
</form>
